/**
 * Created by pzf on 2018/12/26
 *
 */
import FlexTable from './FlexTable';
export default FlexTable;
//# sourceMappingURL=index.js.map
